module.exports = __webpack_public_path__ + "static/fonts/Nexa_Light.1be8e55.otf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Nexa/Nexa_Light.otf
// module id = 2Z1F
// module chunks = 3